import { useEffect, useState } from 'react'
import { Container } from '@material-ui/core'
import { Loader } from 'rsuite'
import NavBar from '../../components/NavBar/NavBar'
import GraficoMinutos from '../../components/GraficoMinu/graficoMinu'
import GraficoHoras from '../../components/GraficoHoras/graficoHoras'
import api from '../../services/api'
export default function Gestao() {
  const [avulsas, setAvulsas] = useState([])
  const [empresas, setEmpresas] = useState([])
  const [loading, seLoading] = useState(true)

  async function getData() {
    await api('/avulsas').then(({ data }) => {
      setAvulsas(data)
    })
    await api(`/expendedtime`).then(({ data }) => {
      setEmpresas(data)
    })
    seLoading(false)
  }
  useEffect(() => {
    getData()
  }, [])
  return (
    <NavBar>
      <Container>
        {loading && <Loader content="loading" />}

        <br />
        {!loading && (
          <div>
            <div className="titleSection">
              <h5>Horas por empresa</h5>
            </div>
            <GraficoHoras empAvulsas={avulsas} />
          </div>
        )}
        <br />
        {!loading && (
          <div>
            <div className="titleSection">
              <h5>Consumo de horas por empresa</h5>
              <GraficoMinutos bodyEmp={empresas} />
            </div>
          </div>
        )}
      </Container>
    </NavBar>
  )
}
